import i18n from "@/language/i18n";
import PROJECT_MANAGEMENT_WIDGETS from "@/configuration/widgets/PROJECT_MANAGEMENT_WIDGETS";

const PROJECT_MANAGEMENT_MODULE_WINDOW_IDENTIFIER = Object.freeze({
    PROJECTS_MODULE_WINDOW_ID: 'projects',
    PROJECT_WORKFLOW_MODULE_WINDOW_ID: 'projectWorkflow',
    PLANNING_EVALUATION_MODULE_WINDOW_ID: 'planningReview',
});

export { PROJECT_MANAGEMENT_MODULE_WINDOW_IDENTIFIER };

export default {
    PROJECT_MANAGMENT_GROUP_WRAPPER: {
        type: 'group',
        id: 'projectManagement',
        label: i18n.t('ModuleRegistry.groups.projectManagement.name'),
        children: [],
        icon: '$wPlanning',
        sidebarIcon: '$wNavProjectManagment'
    },
    CHILDREN: {
        PROJECTS_MODULE: {
            type: 'module',
            id: 'projectsOverview',
            windowIdentifierType: PROJECT_MANAGEMENT_MODULE_WINDOW_IDENTIFIER.PROJECTS_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.projectManagement.projectsOverview.label'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/projects',
            globalSearch: {
                index: 'projects',
                presentation: i18n.t('ModuleRegistry.groups.projectManagement.projectsOverview.presentation'),
                component: 'ProjectItem',
                shortcut: '-p'
            },
            widgets: PROJECT_MANAGEMENT_WIDGETS.PROJECT_WIDGETS
        },
        PROJECTS_WORKFLOW: {
            type: 'module',
            hidden: true,
            windowIdentifierType: PROJECT_MANAGEMENT_MODULE_WINDOW_IDENTIFIER.PROJECT_WORKFLOW_MODULE_WINDOW_ID,
        },
        PLANNING_REVIEW_MODULE: {
            type: 'module',
            id: 'planningReview',
            label: i18n.t('ModuleRegistry.groups.projectManagement.planningReview.label'),
            navigationImg: require('@/assets/navigation/items/icon_projectanfragen.svg'),
            routerLink: '/planningreview',
        },
        RESOURCE_PLANNING_MODULE: {
            type: 'module',
            id: 'resourcePlanning',
            label: i18n.t('ModuleRegistry.groups.projectManagement.resourcePlanning.label'),
            navigationImg: require('@/assets/navigation/items/icon_projectanfragen.svg'),
            routerLink: '/resourceplanning',
        },
    }
}
